import Typography from '@/components/Typography';
import { MasterTranslation, TextStyles } from '@/constants';
import { useGlobalState, useResponsive } from '@/hooks';
import { ResponsiveCollection } from '@/interfaces';
import { type FC, useState } from 'react';
import {
  BackButton,
  BackButtonText,
  DataPrivacyWrapper,
  ItemArrow,
  ItemContainer,
  ItemContent,
  PrivacyContainer,
  StyledArrowBackIcon,
  StyledArrowRightIcon,
  Title,
} from './DataPrivacy.styles';
import DeleteAccount from './components/DeleteAccount';

interface DataPrivacyProps {
  onBackClick: () => void;
}

enum DataPrivacyViewState {
  DATA_PRIVACY = 'data_privacy',
  DELETE_ACCOUNT = 'delete_account',
}

const DataPrivacy: FC<DataPrivacyProps> = ({ onBackClick }) => {
  const { t, isLoggedIn } = useGlobalState();
  const { isDesktopPMT } = useResponsive([ResponsiveCollection.DesktopPMT]);
  const [viewState, setViewState] = useState<DataPrivacyViewState>(DataPrivacyViewState.DATA_PRIVACY);

  const navigateToDeleteAccount = () => {
    setViewState(DataPrivacyViewState.DELETE_ACCOUNT);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (viewState === DataPrivacyViewState.DELETE_ACCOUNT) {
    return <DeleteAccount onBackClick={() => setViewState(DataPrivacyViewState.DATA_PRIVACY)} />;
  }

  return (
    <DataPrivacyWrapper>
      <BackButton onClick={onBackClick}>
        <StyledArrowBackIcon title='Back arrow' />
        <BackButtonText>{t(MasterTranslation.AccBackToPreviousPage)}</BackButtonText>
      </BackButton>

      <Title variant={isDesktopPMT ? TextStyles['Heading 1'] : TextStyles['Heading 2']}>
        {t(MasterTranslation.AccDataAndPrivacy)}
      </Title>

      <PrivacyContainer isDesktopPMT={isDesktopPMT}>
        <ItemContainer onClick={() => window.open('https://parcelmonitor.com/privacy', '_blank')}>
          <ItemContent>
            <Typography variant={isDesktopPMT ? TextStyles['Body Text Large'] : TextStyles['Body Text Small']}>
              {t(MasterTranslation.AccPrivacyPolicy)}
            </Typography>
          </ItemContent>
          <ItemArrow>
            <StyledArrowRightIcon title='Right arrow' />
          </ItemArrow>
        </ItemContainer>
        {isLoggedIn && (
          <ItemContainer onClick={navigateToDeleteAccount}>
            <ItemContent>
              <Typography variant={isDesktopPMT ? TextStyles['Body Text Large'] : TextStyles['Body Text Small']}>
                {t(MasterTranslation.AccDeleteAccountCtaCaps)}
              </Typography>
            </ItemContent>
            <ItemArrow>
              <StyledArrowRightIcon title='Right arrow' />
            </ItemArrow>
          </ItemContainer>
        )}
      </PrivacyContainer>
    </DataPrivacyWrapper>
  );
};

export default DataPrivacy;
